import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/news';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-foreground-200/10">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-72 flex-shrink-0">
            <Link to="/" className="inline-flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500">
                <i className="ri-fire-fill text-foreground-950 text-lg"></i>
              </div>
              <span className="text-foreground-950 font-heading font-bold text-lg tracking-wide">
                51黑料吃瓜网
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-8">
            {categories.map((cat) => (
              <div key={cat.slug}>
                <h4 className="text-foreground-800 font-heading font-bold text-sm mb-4">
                  {cat.name}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  <li>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      最新{cat.name}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      热门{cat.name}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      本周{cat.name}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}合集
                    </Link>
                  </li>
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:w-56 flex-shrink-0">
            <p className="text-foreground-800 font-heading font-bold text-2xl mb-1">
              &copy; 2026
            </p>
            <p className="text-foreground-400 text-sm mb-1">51黑料吃瓜网</p>
            <p className="text-foreground-400 text-sm mb-5">All rights reserved.</p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer underline text-sm whitespace-nowrap">
                微博
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer underline text-sm whitespace-nowrap">
                公众号
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer underline text-sm whitespace-nowrap">
                抖音
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer underline text-sm whitespace-nowrap">
                小红书
              </a>
            </div>

            <div className="mt-6">
              <p className="text-foreground-400 text-xs leading-relaxed mb-3">
                订阅每日爆料，第一时间获取最新大瓜
              </p>
              <form
                data-readdy-form
                action="https://readdy.ai/api/form/d90i4j04jh3v1cgksmdg"
                method="POST"
                className="flex gap-2"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱"
                  required
                  className="flex-1 px-3 py-2 text-sm bg-transparent border border-foreground-300/40 rounded-lg text-foreground-700 placeholder:text-foreground-300 focus:outline-none focus:border-primary-500 transition-colors duration-200"
                />
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="form-honeypot"
                />
                <button
                  type="submit"
                  className="px-4 py-2 bg-primary-500 text-foreground-950 text-sm font-medium rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-1"
                >
                  订阅 <i className="ri-arrow-right-line text-xs"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-200/10">
        <div className="w-full px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-1">
            <div className="w-16 h-10 rounded-md overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20dark%20geometric%20pattern%20with%20warm%20orange%20accents%2C%20minimalist%20design%2C%20charcoal%20background%2C%20subtle%20texture%2C%20modern%20aesthetic%2C%20clean%20lines%2C%20mysterious%20vibe&width=160&height=100&seq=footer-thumb-01&orientation=landscape"
                alt="51黑料吃瓜网"
                title="51黑料吃瓜网 娱乐资讯"
                className="w-full h-full object-cover rounded-md"
              />
            </div>
          </div>
          <p className="text-foreground-300 text-xs">
            本站内容来源于网络公开信息，如有侵权请联系删除
          </p>
          <div className="flex items-center gap-4 text-foreground-300 text-xs">
            <Link to="/about" className="hover:text-foreground-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">关于我们</Link>
            <a href="#" className="hover:text-foreground-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-foreground-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}